import { ConfirmationPrompt } from 'ui/modal';
import {
  StyledErrorModalContainer,
  ErrorModalFooterHideChild,
} from 'modules/ai/nba/components/NBACreationErrorModal.styles';

export interface NBACreationErrorModalProps {
  onClose: () => void;
  onRetry: () => void;
}

export const nbaReengageErrorModalIds = {
  nbaCreationErrorModal: 'nba-creation-error-modal',
};

export const NBACreationErrorModal: React.FC<
  React.PropsWithChildren<NBACreationErrorModalProps>
> = ({ onClose, onRetry }) => {
  return (
    <StyledErrorModalContainer>
      <ErrorModalFooterHideChild
        id={nbaReengageErrorModalIds.nbaCreationErrorModal}
        data-test={nbaReengageErrorModalIds.nbaCreationErrorModal}
        onDiscard={onClose}
        onResume={onRetry}
        discardLabel="Something went wrong."
        discardHelpText=" The campaign could not be created."
        resumeButtonLabel="Try again"
        discardButtonLabel="Close"
        promptType={ConfirmationPrompt.DISCARD}
      >
        {null}
      </ErrorModalFooterHideChild>
    </StyledErrorModalContainer>
  );
};
